import { useMemo } from "react";
import { useListAndSearchAllInvestments } from "@bn/api/apiv1";
import { useDashboardSelectedGroupsContext } from "@features/dashboard/DashboardSelectedGroupProvider";

export const useSelectedInvestments = (enabled = true) => {
  const { accountIds, isFetching: isAccountsFetching } =
    useDashboardSelectedGroupsContext();

  const { data: investmentsResult, isLoading: isInvestmentsLoading } =
    useListAndSearchAllInvestments(
      { accountId: accountIds },
      { enabled: enabled && Boolean(accountIds?.length) }
    );

  const investments = useMemo(
    () => investmentsResult?.investments ?? [],
    [investmentsResult]
  );

  const uniqueIsins = useMemo(
    () =>
      Array.from(
        new Set(
          investments.filter((inv) => inv.hasValidIsin).map((inv) => inv.isin)
        )
      ),
    [investments]
  );

  return {
    accountIds,
    investments,
    uniqueIsins,
    isAccountsFetching,
    isInvestmentsLoading,
  };
};
